module.exports = "<p>\n  project-info works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/work/project-info.component.html
// module id = ./src/app/work/project-info.component.html
// module chunks = main